import { Society } from 'types';
import { getCommunication } from './getCommunication';
import { getTemplate } from './getTemplate';

type Props = {
  subject: string;
  actualSociety: Society;
  userId: string;
};

export const getEmailData = ({ subject, actualSociety, userId }: Props) => {
  const templateBody = getCommunication(actualSociety);
  const template = getTemplate(actualSociety?.societyLanguage || 'es');

  const emailData = {
    subject,
    template,
    templateData: [
      {
        name: 'societyName',
        content: actualSociety?.name,
      },
    ],
    templateBody,
    user: userId,
    society: actualSociety?._id,
    date: new Date(),
    status: 'SENT',
  };

  return emailData;
};
